<template>
    <div component="doc">
        <div class="content">
            <section class="header">
                <h1>FORMS</h1>
            </section>
            <section>
                <div class="name">
                    <h2><span>Attribute:</span>Name</h2>
                </div>
                <div class="content">
                    <div class="demo">
                        <div class="desc" contenteditable="">size="big"</div>
                        <p>ColorDoc</p>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ColorDoc',

    data() {
        return {};
    },

    components: {},
};
</script>

<style lang="less" scoped></style>
